import React, { useState, useEffect } from 'react';
import { api } from '../../api';

const parseDate = (d) => { if (!d) return null; if (d?.seconds) return new Date(d.seconds * 1000); return new Date(d); };

const PagosSection = () => {
  const [vehiculos,       setVehiculos]       = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [searchTerm,      setSearchTerm]      = useState('');
  const [filterStatus,    setFilterStatus]    = useState('all');
  const [selectedVehiculo, setSelectedVehiculo] = useState(null);
  const [historialPagos,  setHistorialPagos]  = useState([]);
  const [loadingHistorial, setLoadingHistorial] = useState(false);

  useEffect(() => { loadVehiculos(); }, []);

  const loadVehiculos = async () => {
    try {
      setLoading(true);
      const data = await api.get('/vehiculos');
      setVehiculos(Array.isArray(data) ? data : data.vehiculos || []);
    } catch (error) {
      console.error('Error cargando vehículos:', error);
    } finally {
      setLoading(false);
    }
  };

  const togglePaymentStatus = async (vehicleId, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      const updates = { isPaid: newStatus };
      if (newStatus) {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        updates.fechaVencimiento = nextMonth.toISOString();
      }
      await api.put(`/vehiculos/admin/${vehicleId}`, updates);
      setVehiculos(prev => prev.map(v => (v.id || v._id) === vehicleId ? { ...v, ...updates } : v));
      alert(`Estado de pago ${newStatus ? 'activado' : 'desactivado'} correctamente`);
    } catch (error) {
      alert('Error al cambiar estado de pago: ' + error.message);
    }
  };

  const showHistorialPagos = async (vehiculo) => {
    setSelectedVehiculo(vehiculo);
    setLoadingHistorial(true);
    try {
      const data = await api.get(`/pagos?aditamento=${encodeURIComponent(vehiculo.aditamento)}`);
      const pagos = Array.isArray(data) ? data : data.pagos || [];
      setHistorialPagos(pagos.sort((a, b) => new Date(b.fechaPago) - new Date(a.fechaPago)));
    } catch (error) {
      console.error('Error al obtener historial de pagos:', error);
      setHistorialPagos([]);
    } finally {
      setLoadingHistorial(false);
    }
  };

  const closeHistorialModal = () => {
    setSelectedVehiculo(null);
    setHistorialPagos([]);
  };

  const extendSubscription = async (vehicleId, months = 1) => {
    try {
      const vehicle = vehiculos.find(v => (v.id || v._id) === vehicleId);
      let currentExpiry = new Date();
      if (vehicle?.fechaVencimiento) {
        const parsed = parseDate(vehicle.fechaVencimiento);
        if (parsed && parsed > new Date()) currentExpiry = parsed;
      }
      currentExpiry.setMonth(currentExpiry.getMonth() + months);
      const updates = { fechaVencimiento: currentExpiry.toISOString(), isPaid: true };
      await api.put(`/vehiculos/admin/${vehicleId}`, updates);
      setVehiculos(prev => prev.map(v => (v.id || v._id) === vehicleId ? { ...v, ...updates } : v));
      alert(`Suscripción extendida por ${months} mes(es)`);
    } catch (error) {
      alert('Error al extender suscripción: ' + error.message);
    }
  };

  const isExpired = (fechaVencimiento) => {
    const expiry = parseDate(fechaVencimiento);
    return expiry ? expiry < new Date() : false;
  };

  const getDaysUntilExpiry = (fechaVencimiento) => {
    const expiry = parseDate(fechaVencimiento);
    if (!expiry) return null;
    return Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));
  };

  const filteredVehiculos = vehiculos.filter(v => {
    const matchesSearch =
      v.aditamento?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      v.patente?.toLowerCase().includes(searchTerm.toLowerCase());
    let matchesStatus = true;
    if (filterStatus === 'paid')    matchesStatus = v.isPaid === true;
    if (filterStatus === 'unpaid')  matchesStatus = v.isPaid !== true;
    if (filterStatus === 'expired') matchesStatus = isExpired(v.fechaVencimiento);
    return matchesSearch && matchesStatus;
  });

  if (loading) return (
    <div className="section-loading"><div className="spinner"></div><p>Cargando información de pagos...</p></div>
  );

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>Gestión de Pagos</h1>
        <p>Administre suscripciones, vencimientos y estados de pago</p>
      </div>

      <div className="filters-container">
        <div className="search-container">
          <input type="text" placeholder="Buscar por aditamento o patente..."
            value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="search-input" />
        </div>
        <div className="filter-buttons">
          {[
            ['all',     `Todos (${vehiculos.length})`],
            ['paid',    `Pagados (${vehiculos.filter(v => v.isPaid).length})`],
            ['unpaid',  `No Pagados (${vehiculos.filter(v => !v.isPaid).length})`],
            ['expired', `Vencidos (${vehiculos.filter(v => isExpired(v.fechaVencimiento)).length})`],
          ].map(([val, label]) => (
            <button key={val} className={`filter-btn ${filterStatus === val ? 'active' : ''}`}
              onClick={() => setFilterStatus(val)}>{label}</button>
          ))}
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Aditamento</th><th>Patente</th><th>Estado Pago</th>
              <th>Fecha Vencimiento</th><th>Días Restantes</th><th>Fecha Registro</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredVehiculos.map(vehiculo => {
              const vid      = vehiculo.id || vehiculo._id;
              const daysLeft = getDaysUntilExpiry(vehiculo.fechaVencimiento);
              const expired  = isExpired(vehiculo.fechaVencimiento);
              const vencDate = parseDate(vehiculo.fechaVencimiento);
              const regDate  = parseDate(vehiculo.fechaRegistro);
              return (
                <tr key={vid} className={expired ? 'expired-row' : ''}>
                  <td>
                    <span className="aditamento-badge" style={{ cursor: 'pointer' }}
                      onClick={() => showHistorialPagos(vehiculo)}
                      title="Click para ver historial de pagos">
                      {vehiculo.aditamento || 'N/A'}
                    </span>
                  </td>
                  <td><strong>{vehiculo.patente || 'N/A'}</strong></td>
                  <td>
                    <button className={`payment-toggle ${vehiculo.isPaid ? 'paid' : 'unpaid'}`}
                      onClick={() => togglePaymentStatus(vid, vehiculo.isPaid)}
                      title={`Click para ${vehiculo.isPaid ? 'marcar como no pagado' : 'marcar como pagado'}`}>
                      {vehiculo.isPaid ? '✅ Pagado' : '❌ No Pagado'}
                    </button>
                  </td>
                  <td>{vencDate ? vencDate.toLocaleDateString() : 'N/A'}</td>
                  <td>
                    {daysLeft !== null ? (
                      <span className={`days-badge ${expired ? 'expired' : daysLeft <= 7 ? 'warning' : 'normal'}`}>
                        {expired ? `Vencido ${Math.abs(daysLeft)} días` : daysLeft <= 0 ? 'Vence hoy' : `${daysLeft} días`}
                      </span>
                    ) : 'N/A'}
                  </td>
                  <td>{regDate ? regDate.toLocaleDateString() : 'N/A'}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn btn-sm btn-success" onClick={() => extendSubscription(vid, 1)} title="Extender 1 mes">+1 Mes</button>
                      <button className="btn btn-sm btn-warning" onClick={() => extendSubscription(vid, 3)} title="Extender 3 meses">+3 Meses</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filteredVehiculos.length === 0 && <div className="no-data"><p>No se encontraron vehículos con los filtros aplicados</p></div>}
      </div>

      <div className="stats-summary">
        <div className="stat-card"><h4>Total Vehículos</h4><span className="stat-number">{vehiculos.length}</span></div>
        <div className="stat-card success"><h4>Suscripciones Vigentes</h4><span className="stat-number">{vehiculos.filter(v => v.isPaid).length}</span></div>
        <div className="stat-card warning">
          <h4>Vencen en 7 días</h4>
          <span className="stat-number">{vehiculos.filter(v => { const d = getDaysUntilExpiry(v.fechaVencimiento); return d !== null && d >= 0 && d <= 7; }).length}</span>
        </div>
        <div className="stat-card danger"><h4>Vencidos</h4><span className="stat-number">{vehiculos.filter(v => isExpired(v.fechaVencimiento)).length}</span></div>
      </div>

      {selectedVehiculo && (
        <div className="modal-overlay" onClick={closeHistorialModal}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-content" onClick={e => e.stopPropagation()}
            style={{ background: 'white', borderRadius: '15px', padding: 0, width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
            <div className="modal-header"
              style={{ background: 'linear-gradient(135deg, #74C8D2 0%, #444242 100%)', color: 'white', padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: '1.5rem' }}>Historial de Pagos - Aditamento {selectedVehiculo.aditamento}</h3>
              <button onClick={closeHistorialModal}
                style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer', padding: '5px', borderRadius: '50%' }}
                onMouseOver={e => e.target.style.background = 'rgba(255,255,255,0.2)'}
                onMouseOut={e => e.target.style.background = 'none'}>×</button>
            </div>

            <div style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px', marginBottom: '20px' }}>
                {[
                  ['Total Pagos',  historialPagos.length],
                  ['Monto Total',  `$${historialPagos.reduce((s, p) => s + (p.montoReal || p.montoEstimado || 0), 0).toLocaleString()}`],
                  ['Último Pago',  historialPagos.length > 0 ? parseDate(historialPagos[0].fechaPago)?.toLocaleDateString() : '-'],
                  ['Estado',       historialPagos.length > 0 ? '✅ Al día' : '❌ Sin pagos'],
                ].map(([label, val]) => (
                  <div key={label} style={{ background: '#f8f9fa', padding: '15px', borderRadius: '10px', textAlign: 'center' }}>
                    <h5 style={{ color: '#666', fontSize: '12px', marginBottom: '5px', textTransform: 'uppercase' }}>{label}</h5>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333' }}>{val}</div>
                  </div>
                ))}
              </div>

              {loadingHistorial ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>Cargando historial de pagos...</div>
              ) : historialPagos.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}><p>No hay pagos registrados para este aditamento</p></div>
              ) : (
                <div style={{ display: 'grid', gap: '15px' }}>
                  {historialPagos.map(pago => {
                    const fechaPago = parseDate(pago.fechaPago);
                    return (
                      <div key={pago.id} style={{ border: '1px solid #dee2e6', borderRadius: '10px', padding: '15px', background: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                          <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#28a745' }}>
                            ${pago.montoReal || pago.montoEstimado || 'N/A'} {pago.moneda || 'ARS'}
                          </div>
                          <div style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', background: '#d4edda', color: '#155724' }}>✅ Aprobado</div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                          {[
                            ['📅 Fecha:', fechaPago ? fechaPago.toLocaleString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A'],
                            ['🔗 ID MercadoPago:', pago.mercadoPagoId],
                            ['📝 Tipo:', pago.tipoTransaccion],
                            ['🚕 Aditamento:', pago.aditamento],
                          ].map(([label, val]) => val && (
                            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                              <span style={{ color: '#666', fontWeight: '500' }}>{label}</span>
                              <span style={{ fontWeight: 'bold' }}>{val}</span>
                            </div>
                          ))}
                          {pago.error && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                              <span style={{ color: '#dc3545', fontWeight: '500' }}>⚠️ Nota:</span>
                              <span style={{ fontWeight: 'bold', color: '#dc3545' }}>{pago.error}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PagosSection;
